import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Illustration } from './common/Illustration';

const PRESETS: Record<number, { title: string; message: string }> = {
  401: { title: 'Not signed in', message: 'You need to log in to view this page.' },
  403: { title: 'Access denied', message: "You don't have permission to view this page." },
  404: { title: 'Page not found', message: "The page you're looking for doesn't exist or may have moved." },
  429: { title: 'Too many requests', message: 'You are going a little fast. Please try again in a moment.' },
  500: { title: 'Something went wrong', message: 'An unexpected error occurred. Please try again.' },
};

export function ErrorPage({ code = 404, onReset }: { code?: number; onReset?: () => void }) {
  const navigate = useNavigate();
  const preset = PRESETS[code] ?? PRESETS[404];

  const goBack = () => {
    onReset?.();
    navigate(-1);
  };
  const goHome = () => {
    onReset?.();
    navigate('/');
  };

  return (
    <section className="adaptive-page error-page">
      <div className="error-card glass-surface">
        <Illustration context={code === 404 ? 'error.404' : 'error.500'} size="sm" style={{ margin: '0 auto 16px auto', display: 'block', maxHeight: '130px' }} />
        <span className="error-code" aria-hidden="true">{code}</span>
        <h1>{preset.title}</h1>
        <p>{preset.message}</p>
        <div className="error-actions">
          <button type="button" className="secondary-action" onClick={goBack}>
            <ArrowLeft size={17} aria-hidden="true" /> Go back
          </button>
          <button type="button" className="primary-action" onClick={goHome}>
            <Home size={17} aria-hidden="true" /> Home
          </button>
        </div>
      </div>
    </section>
  );
}
